import React from 'react'

const AddIcon = () => {
  return (
   <svg xmlns="http://www.w3.org/2000/svg" width={15} height={15} viewBox="0 0 15 15" fill="none">
        <g clipPath="url(#clip0_14828_8217)">
            <path d="M7.50012 15.0001C7.27876 14.9998 7.06654 14.9118 6.91002 14.7552C6.75349 14.5987 6.66544 14.3865 6.66516 14.1651V8.33506H0.835078C0.613602 8.33506 0.401196 8.24708 0.244589 8.09047C0.0879812 7.93387 0 7.72146 0 7.49998C0 7.27851 0.0879812 7.0661 0.244589 6.9095C0.401196 6.75289 0.613602 6.66491 0.835078 6.66491H6.66516V0.835063C6.66516 0.613591 6.75314 0.401189 6.90974 0.244584C7.06635 0.0879797 7.27875 0 7.50022 0C7.72169 0 7.93409 0.0879797 8.0907 0.244584C8.2473 0.401189 8.33528 0.613591 8.33528 0.835063V6.66514H14.1652C14.3866 6.66514 14.599 6.75312 14.7556 6.90973C14.9123 7.06634 15.0002 7.27874 15.0002 7.50022C15.0002 7.7217 14.9123 7.9341 14.7556 8.09071C14.599 8.24732 14.3866 8.3353 14.1652 8.3353H8.33508V14.1651C8.3348 14.3865 8.24674 14.5987 8.09022 14.7552C7.93369 14.9118 7.72148 14.9998 7.50012 15.0001Z" fill="#FDFDFD" />
        </g>
        <defs>
            <clipPath id="clip0_14828_8217">
            <rect width={15} height={15} fill="white" />
            </clipPath>
        </defs>
    </svg>

  )
}

export default AddIcon